import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Home from "./pages/Home/Home";
import { CssBaseline } from "@mui/material";
import "../src/assets/styles/custom-style.scss";
import theme from "./assets/themes/theme";
import Industries from "./pages/Industries/Industries";
import General from "./pages/General/General";
import InvoicesAndBills from "./pages/General/InvoicesAndBills";
import HrAndPayroll from "./pages/General/HrAndPayroll";
import BankingAndFinancial from "./pages/BankingAndFinancial/BankingAndFinancial";
import AccountStatements from "./pages/BankingAndFinancial/AccountStatements";
import Cheques from "./pages/BankingAndFinancial/Cheques";
import TradeFinanceDocuments from "./pages/BankingAndFinancial/TradeFinanceDocuments";
import Insurance from "./pages/Insurance/Insurance";
import MedicalClaims from "./pages/Insurance/MedicalClaims";
import MembershipCards from "./pages/Insurance/MembershipCards";
import PolicyDocuments from "./pages/Insurance/PolicyDocuments";
import Government from "./pages/Government/Government";
import CertificatesPermitsLicenses from "./pages/Government/CertificatesPermitsLicenses";
import IdentityCards from "./pages/Government/IdentityCards";
import Immigrations from "./pages/Government/Immigrations";
import Taxation from "./pages/Government/Taxation";
import Healthcare from "./pages/Healthcare/Healthcare";
import LabReports from "./pages/Healthcare/LabReports";
import Education from "./pages/Education/Education";
import UniversityDegrees from "./pages/Education/UniversityDegrees";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Technology from "./pages/Technology/Technology";
import Overview from "./pages/Technology/Overview";
import DeploymentOptions from "./pages/Technology/DeploymentOptions";
import IntegrationOptions from "./pages/Technology/IntegrationOptions";
import PDFGeneration from "./pages/Technology/PDFGeneration";
import SecurityAndPrivacy from "./pages/Technology/SecurityAndPrivacy";
import Pricing from "./pages/Pricing/Pricing";
import NotFound from "./pages/NotFound/NotFound";
import CaseStudy from "./pages/CaseStudy/CaseStudy";
import CaseStudyDocumentSecurity from "./pages/CaseStudy/CaseStudyDocumentSecurity";
import CaseStudyEducation from "./pages/CaseStudy/CaseStudyEducation";
import CaseStudyAshoka from "./pages/CaseStudy/CaseStudyAshoka";
import CaseStudyKaribia from "./pages/CaseStudy/CaseStudyKaribia";
import BankingWhitepaper from "./pages/Whitepapers/BankingWhitepaper";
import DocumentSecurityWhitepaper from "./pages/Whitepapers/DocumentSecurityWhitepaper";
import EUDCCWhitepaper from "./pages/Whitepapers/EUDCCWhitepaper";
import HRDocumentSecurityWhitepaper from "./pages/Whitepapers/HRDocumentSecurityWhitepaper";
import PDFStampingWhitepaper from "./pages/Whitepapers/PDFStampingWhitepaper";
import TestingInspectionWhitepaper from "./pages/Whitepapers/TestingInspectionWhitepaper";
import Banking from "./pages/Whitepapers/Banking";
import AllWhitepapers from "./pages/Whitepapers/AllWhitepapers";
import DocumentSecurity from "./pages/Whitepapers/DocumentSecurity";
import EuDCC from "./pages/Whitepapers/EuDCC";
import HrDocumentSecurity from "./pages/Whitepapers/HrDocumentSecurity";
import InfoGraphic from "./pages/Whitepapers/InfoGraphic";
import PDFStamping from "./pages/Whitepapers/PDFStamping";
import TestingInspection from "./pages/Whitepapers/TestingInspection";
import Contact from "./pages/Contact/Contact";
import AboutUs from "./pages/AboutUs/AboutUs";
import TermsOfService from "./pages/TermsAndPolicy/TermsOfService";
import PrivacyPolicy from "./pages/TermsAndPolicy/PrivacyPolicy";
import FAQ from "./pages/FAQ/FAQ";
import Blog from "./pages/Blog/Blog";
import BlogDetails from "./pages/Blog/BlogDetails";
import { BlogData, getRandomData } from "./pages/Blog/BlogData";
import CookiePreferencesButton from "./components/CookieSetting";
import { getConsent, setConsent } from "./utils/CookieConsent";
import { useTranslation } from "react-i18next";
import { createPortal } from "react-dom";

const CookieModal = ({ children }) => createPortal(children, document.body);

const ToggleSwitch = ({ checked, onChange }) => (
  <div
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log("after prevent:", e.defaultPrevented);
      onChange(!checked);
    }}
    style={{
      position: "relative",
      width: "50px",
      height: "26px",
      flexShrink: 0,
      marginTop: "4px",
      cursor: "pointer",
    }}
  >
    <span
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: checked ? "#c3f0f7" : "#ccc",
        transition: "0.3s",
        borderRadius: "34px",
      }}
    />
    <span
      style={{
        position: "absolute",
        height: "20px",
        width: "20px",
        left: "3px",
        bottom: "3px",
        backgroundColor: "#266fee",
        transition: "0.3s",
        borderRadius: "50%",
        transform: checked ? "translateX(24px)" : "translateX(0)",
      }}
    />
  </div>
);

const publicUrl = process.env.PUBLIC_URL || "";

// Component NGOÀI: chỉ đọc window.location (chưa nằm trong Router) để xác định:
// - path hiện tại đã có prefix ngôn ngữ (/en, /vi) chưa, có tính luôn phần PUBLIC_URL nếu app
//   được deploy dưới 1 subpath.
// - nếu chưa có thì redirect (full reload) sang bản "/en".
function RoutesWithAnimation({ blogData, randomLink }) {
  const fullPathname = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;

  const pathname =
    publicUrl && fullPathname.startsWith(publicUrl)
      ? fullPathname.slice(publicUrl.length) || "/"
      : fullPathname;

  const hasLocalePrefix =
    pathname === "/en" ||
    pathname === "/vi" ||
    pathname.startsWith("/en/") ||
    pathname.startsWith("/vi/");

  useEffect(() => {
    if (!hasLocalePrefix) {
      const newPath = pathname === "/" ? "/en" : `/en${pathname}`;
      window.location.replace(`${publicUrl}${newPath}${search}${hash}`);
    }
  }, [pathname, search, hash, hasLocalePrefix]);

  if (!hasLocalePrefix) {
    // Đang chờ redirect ở useEffect, không render gì cả
    return null;
  }

  const locale = pathname.startsWith("/vi") ? "vi" : "en";
  const basename = `${publicUrl}/${locale}`;

  return (
    <BrowserRouter basename={basename}>
      <AnimatedRoutes blogData={blogData} randomLink={randomLink} />
    </BrowserRouter>
  );
}

// Component TRONG: nằm bên trong BrowserRouter nên useLocation() dùng được hợp lệ,
// bọc toàn bộ Routes bằng AnimatePresence để có animation chuyển trang.
function AnimatedRoutes({ blogData, randomLink }) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/industries/general-and-hr" element={<General />} />
        <Route
          path="/industries/invoices-and-bills"
          element={<InvoicesAndBills />}
        />
        <Route
          path="/industries/hr-and-payroll"
          element={<HrAndPayroll />}
        />
        <Route
          path="/industries/banking-and-financial"
          element={<BankingAndFinancial />}
        />
        <Route
          path="/industries/account-statements"
          element={<AccountStatements />}
        />
        <Route path="/industries/cheques" element={<Cheques />} />
        <Route
          path="/industries/trade-finance-documents"
          element={<TradeFinanceDocuments />}
        />
        <Route path="/industries/insurance" element={<Insurance />} />
        <Route
          path="/industries/insurance-medical-claims"
          element={<MedicalClaims />}
        />
        <Route
          path="/industries/insurance-membership-cards"
          element={<MembershipCards />}
        />
        <Route
          path="/industries/insurance-policy-documents"
          element={<PolicyDocuments />}
        />
        <Route path="/industries/government" element={<Government />} />
        <Route
          path="/industries/certificates-permits-licenses"
          element={<CertificatesPermitsLicenses />}
        />
        <Route
          path="/industries/identity-cards"
          element={<IdentityCards />}
        />
        <Route
          path="/industries/immigration"
          element={<Immigrations />}
        />
        <Route path="/industries/taxation" element={<Taxation />} />
        <Route path="/industries/healthcare" element={<Healthcare />} />
        <Route path="/industries/lab-reports" element={<LabReports />} />
        <Route path="/industries/education" element={<Education />} />
        <Route
          path="/industries/university-degrees-and-transcripts"
          element={<UniversityDegrees />}
        />
        <Route path="/technology" element={<Technology />} />
        <Route path="/technology/overview" element={<Overview />} />
        <Route
          path="/technology/deployment"
          element={<DeploymentOptions />}
        />
        <Route
          path="/technology/integration"
          element={<IntegrationOptions />}
        />
        <Route
          path="/technology/generating_pdf_reports_and_documents"
          element={<PDFGeneration />}
        />
        <Route
          path="/technology/security"
          element={<SecurityAndPrivacy />}
        />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/case-study" element={<CaseStudy />} />
        <Route
          path="/case-study/document-security"
          element={<CaseStudyDocumentSecurity />}
        />
        <Route
          path="/case-study/education"
          element={<CaseStudyEducation />}
        />
        <Route path="/case-study/ashoka" element={<CaseStudyAshoka />} />
        <Route
          path="/case-study/karibia"
          element={<CaseStudyKaribia />}
        />
        <Route path="/whitepapers" element={<AllWhitepapers />} />
        <Route
          path="/whitepapers/banking-whitepaper"
          element={<BankingWhitepaper />}
        />
        <Route path="/whitepapers/banking" element={<Banking />} />
        <Route
          path="/whitepapers/document-security-whitepaper"
          element={<DocumentSecurityWhitepaper />}
        />
        <Route
          path="/whitepapers/document-security"
          element={<DocumentSecurity />}
        />
        <Route
          path="/whitepapers/eu-dcc-whitepaper"
          element={<EUDCCWhitepaper />}
        />
        <Route path="/whitepapers/eu-dcc" element={<EuDCC />} />
        <Route
          path="/whitepapers/hr-document-security-whitepaper"
          element={<HRDocumentSecurityWhitepaper />}
        />
        <Route
          path="/whitepapers/hr-document-security"
          element={<HrDocumentSecurity />}
        />
        <Route
          path="/whitepapers/pdf-stamping-whitepaper"
          element={<PDFStampingWhitepaper />}
        />
        <Route
          path="/whitepapers/pdf-stamping"
          element={<PDFStamping />}
        />
        <Route
          path="/whitepapers/testing-inspection-whitepaper"
          element={<TestingInspectionWhitepaper />}
        />
        <Route
          path="/whitepapers/testing-inspection"
          element={<TestingInspection />}
        />
        <Route
          path="/whitepapers/infographic-on-bank-fraud"
          element={<InfoGraphic />}
        />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/blog" element={<Blog />} />
        {blogData.map((data, index) => (
          <Route
            path={`/blog${data.url}`}
            key={data.id}
            element={
              <BlogDetails
                title={data.title}
                image={data.image}
                children={data.body}
                randomLink={randomLink}
              />
            }
          />
        ))}
      </Routes>
    </AnimatePresence>
  );
}

const App = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [functional, setFunctional] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [showModal]);
  // Hiển thị banner nếu CHƯA có consent
  useEffect(() => {
    const saved = getConsent();
    if (!saved) {
      setShowBanner(true);
    }
  }, []);

  // Sync trạng thái toggle khi mở modal
  useEffect(() => {
    if (!showModal) return;
    const saved = getConsent();
    if (saved) {
      setFunctional(!!saved.functional);
      setAnalytics(!!saved.analytics);
      setMarketing(!!saved.marketing);
    }
  }, [showModal]);

  const acceptAll = () => {
  const allPrefs = {
      functional: true,
      analytics: true,
      marketing: true,
    };
    setConsent(allPrefs);
      // Set cookie for non-www domain
    document.cookie = `cookie_preferences_qrypto=${encodeURIComponent(
      JSON.stringify(allPrefs)
    )}; path=/; domain=.qrypto.mobile-id.vn; max-age=31536000; SameSite=Lax`;
    
    setShowBanner(false);
  };

  const rejectAll = () => {
     const rejectPrefs = {
      functional: false,
      analytics: false,
      marketing: false,
    };
    setConsent(rejectPrefs);
    
    // Set cookie for non-www domain
    document.cookie = `cookie_preferences_qrypto=${encodeURIComponent(
      JSON.stringify(rejectPrefs)
    )}; path=/; domain=.qrypto.mobile-id.vn; max-age=31536000; SameSite=Lax`;
    
    setShowBanner(false);
  };

 const savePreferences = () => {
    const prefs = {
      functional,
      analytics,
      marketing,
    };
    setConsent(prefs);
    
    // Set cookie for non-www domain
    document.cookie = `cookie_preferences_qrypto=${encodeURIComponent(
      JSON.stringify(prefs)
    )}; path=/; domain=.qrypto.mobile-id.vn; max-age=31536000; SameSite=Lax`;
    
    if (!functional) {
      localStorage.removeItem("i18nextLng");
    }

    setShowModal(false);
    setShowBanner(false);
  };

  useEffect(() => {
    window.history.scrollRestoration = "auto";
  }, []);

  const blogData = BlogData();

  const randomLink = getRandomData(blogData);

  console.log("URL", process.env.PUBLIC_URL);

  const bannerRef = useRef(null);
  const [bannerHeight, setBannerHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      if (showBanner && bannerRef.current) {
        const height = bannerRef.current.offsetHeight;
        setBannerHeight(height);
        document.documentElement.style.setProperty(
          "--cookie-banner-height",
          `${height}px`
        );
      } else {
        setBannerHeight(0);
        document.documentElement.style.setProperty(
          "--cookie-banner-height",
          "0px"
        );
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
      document.documentElement.style.setProperty(
        "--cookie-banner-height",
        "0px"
      );
    };
  }, [showBanner]);
  useLayoutEffect(() => {
    if (!showBanner || !bannerRef.current) {
      setBannerHeight(0);
      return;
    }

    const height = bannerRef.current.offsetHeight;
    setBannerHeight(height);

    // Resize observer để bắt mọi thay đổi kích thước (do text wrap, ngôn ngữ, font load, v.v.)
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setBannerHeight(entry.target.offsetHeight);
      }
    });

    resizeObserver.observe(bannerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [showBanner]); // Chỉ depend vào showBanner

  // Bonus: vẫn giữ resize window để an toàn tuyệt đối
  useEffect(() => {
    const handleResize = () => {
      if (bannerRef.current) {
        setBannerHeight(bannerRef.current.offsetHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [showBanner]);

  return (
    <>
      <CookiePreferencesButton onClick={() => setShowModal(true)} />
      <div
        style={{
          marginBottom: showBanner ? `${bannerHeight}px` : "0px",
          transition: "margin-bottom 0.3s ease",
        }}
      >
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RoutesWithAnimation blogData={blogData} randomLink={randomLink} />
        </ThemeProvider>
      </div>
      {showBanner && (
        <div
          ref={bannerRef}
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            background: "#fff",
            color: "#202641",
            padding: "1%",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            boxShadow: "0 -4px 10px rgba(0,0,0,0.2)",
            fontSize: "15px",
            lineHeight: "1.6",
            zIndex: 9999,
          }}
        >
          {/* Text bên trái */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              flex: "1",
              minWidth: "auto",
              textAlign: "left",
              flexWrap: "wrap",
            }}
          >
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>
              {t("cookie_consent.note")}
            </span>
            <span style={{ fontSize: "15px" }}>
              {t("cookie_consent.note_des")}
            </span>
          </div>

          {/* 3 nút bên phải */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            {/* Cookie Preferences */}
            <button
              onClick={() => setShowModal(true)}
              style={{
                fontFamily: "Montserrat, san-serif",
                background: "transparent",
                color: "#202641",
                border: "1px solid #202641",
                fontSize: "15px",
                fontWeight: 500,
                padding: "10px",
                borderRadius: "6px",
                minWidth: "180px",
                cursor: "pointer",
              }}
            >
              {t("cookie_consent.button_custom")}
            </button>

            {/* Reject All */}
            <button
              onClick={rejectAll}
              style={{
                background: "transparent",
                fontFamily: "Montserrat, san-serif",
                color: "#202641",
                border: "1px solid #202641",
                fontSize: "15px",
                fontWeight: 500,
                padding: "10px",
                borderRadius: "6px",
                minWidth: "180px",
                cursor: "pointer",
              }}
            >
              {t("cookie_consent.button_reject")}
            </button>

            {/* Accept All Cookies */}
            <button
              onClick={acceptAll}
              style={{
                background: "#c3f0f7",
                fontFamily: "Montserrat, san-serif",
                color: "#202641",
                border: "1px solid #c3f0f7",
                fontSize: "15px",
                fontWeight: 500,
                padding: "10px",
                borderRadius: "6px",
                minWidth: "180px",
                cursor: "pointer",
              }}
            >
              {t("cookie_consent.button_accept")}
            </button>
          </div>
        </div>
      )}
      {/* Modal Preferences */}
      {showModal && (
        <CookieModal>
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10000,
              padding: "20px",
            }}
          >
            <div
              style={{
                background: "#fff",
                color: "#202641",
                borderRadius: "10px",
                width: "100%",
                maxWidth: isMobile ? "90dvw" : "60dvw",
                maxHeight: "90vh",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div
                style={{
                  flexShrink: 0,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "16px 24px",
                  borderBottom: "1px solid #202641",
                }}
              >
                <h2
                  style={{
                    color: "#202641",
                    margin: 0,
                    fontSize: "18px",
                    fontWeight: 700,
                  }}
                >
                  {t("cookie_consent.title")}
                </h2>
                <span
                  onClick={() => setShowModal(false)}
                  style={{
                    fontSize: "28px",
                    cursor: "pointer",
                    lineHeight: "1",
                    padding: "4px 8px",
                  }}
                >
                  ×
                </span>
              </div>
              {/* Body */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  overflowY: "auto",
                  padding: "16px 24px",
                  gap: "30px",
                }}
              >
                {/* Strictly Necessary */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "40px",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <strong style={{ fontSize: "16px" }}>
                      {" "}
                      {t("cookie_consent.content1")}
                    </strong>
                    <br />
                    <small
                      style={{
                        opacity: 0.9,
                        lineHeight: "1.5",
                        fontSize: "15px",
                      }}
                    >
                      {t("cookie_consent.des_content1")}
                    </small>
                  </div>
                  <div
                    style={{
                      flexShrink: 0,
                      justifyContent: "center",
                      marginTop: "4px",
                    }}
                  >
                    <strong style={{ color: "#266fee" }}>
                      {t("cookie_consent.always")}
                    </strong>
                  </div>
                </div>

                {/* Functional */}
                <div
                  style={{ display: "flex", gap: "40px", alignItems: "center" }}
                >
                  <div style={{ flex: 1 }}>
                    <strong style={{ fontSize: "16px" }}>
                      {t("cookie_consent.content2")}
                    </strong>
                    <br />
                    <small
                      style={{
                        opacity: 0.9,
                        lineHeight: "1.5",
                        fontSize: "15px",
                      }}
                    >
                      {t("cookie_consent.des_content2")}
                    </small>
                  </div>
                  <ToggleSwitch checked={functional} onChange={setFunctional} />
                </div>

                {/* Analytics */}
                <div
                  style={{ display: "flex", gap: "40px", alignItems: "center" }}
                >
                  <div style={{ flex: 1 }}>
                    <strong style={{ fontSize: "16px" }}>
                      {t("cookie_consent.content3")}
                    </strong>
                    <br />
                    <small
                      style={{
                        opacity: 0.9,
                        lineHeight: "1.5",
                        fontSize: "15px",
                      }}
                    >
                      {t("cookie_consent.des_content3")}
                    </small>
                  </div>
                  <ToggleSwitch checked={analytics} onChange={setAnalytics} />
                </div>

                {/* Marketing */}
                <div
                  style={{ display: "flex", gap: "40px", alignItems: "center" }}
                >
                  <div style={{ flex: 1 }}>
                    <strong style={{ fontSize: "16px" }}>
                      {t("cookie_consent.content4")}
                    </strong>
                    <br />
                    <small
                      style={{
                        opacity: 0.9,
                        lineHeight: "1.5",
                        fontSize: "15px",
                      }}
                    >
                      {t("cookie_consent.des_content4")}
                    </small>
                  </div>
                  <ToggleSwitch checked={marketing} onChange={setMarketing} />
                </div>
              </div>
              {/* Buttons */}
              <div
                style={{
                  flexShrink: 0,
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                  justifyContent: "flex-end",

                  borderTop: "1px solid #202641",
                  flexWrap: "wrap",
                  padding: "16px 24px",
                }}
              >
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  style={{
                    background: "transparent",
                    fontFamily: "Montserrat, san-serif",
                    color: "#202641",
                    border: "1px solid #202641",
                    fontWeight: 500,
                    padding: "10px",
                    borderRadius: "6px",
                    minWidth: "120px",
                    fontSize: "15px",
                  }}
                >
                  {t("cookie_consent.button_cancel")}
                </button>
                <button
                  type="button"
                  onClick={savePreferences}
                  style={{
                    background: "#c3f0f7",
                    fontFamily: "Montserrat, san-serif",
                    color: "#202641",
                    padding: "10px",
                    border: "none",
                    borderRadius: "6px",
                    fontWeight: 500,
                    minWidth: "160px",
                    fontSize: "15px",
                  }}
                >
                  {t("cookie_consent.button_save")}
                </button>
              </div>
            </div>
          </div>
        </CookieModal>
      )}
    </>
  );
};

export default App;